import React, { Component, Fragment } from 'react'
import moment from 'moment'
import fp from 'lodash/fp'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import DialogBox from 'components/dialog-box'
import EvacuationProgressBar from 'components/evacuation-progress-bar'
import SearchableSelectField from 'components/searchable-select-field'
import withClientId from 'hocs/with-client-id'
import { Button, Col, Row, Table } from 'elements'

import {
  blockReportSelector,
  contactAttendanceSelector,
  scheduleDetailsSelector,
  detectablesBlockReportLoadingSelector
} from 'redux/selectors'

import {
  getContactAttendanceForSchedule,
  getSchedule,
  overrideAttendance,
  reportBlockAttendance,
  listScheduleStats
} from 'redux/modules/model/attendance'

import { 
  getAttendanceRate,
  getAbsentCount,
  getPresentCount,
  getProcessedCount
} from 'pages/attendance/helpers'

import { getHolder } from 'redux/modules/model/holder'
import { holderDetailsSelector } from 'redux/selectors'
import {comparePropertiesGraded} from "../../../utils/helpers";

const absenceLabels = {
  'present': "Present",
  'absent': "Absent",
  'auth-absent': "Absent [Authorized]"
}

const sortBlockReport = fp.compose(
  fp.sortBy((item) => item.startTime),
  fp.map((item) => ({
    ...item,
    startTime: moment(item.startTime),
    endTime: moment(item.endTime)
  }))
)

const committerSelector = (state, props) =>
  fp.compose(
    fp.find({ clientReference: props.match.params.clientReference }),
    fp.defaultTo([]),
    fp.get('attendance'),
    contactAttendanceSelector
  )(state)

const getHolderProgrammeSelector = fp.compose(
  fp.get('metadata.programme'),
  fp.defaultTo({}),
  holderDetailsSelector
)

export class AttendanceScheduleBlockDrilldown extends Component {
  static propTypes = {
    blockReport: PropTypes.array,
    committer: PropTypes.object,
    getContactAttendanceForSchedule: PropTypes.func,
    getSchedule: PropTypes.func,
    match: PropTypes.object,
    reportBlockAttendance: PropTypes.func,
    schedule: PropTypes.object,
  }

  constructor(props) {
    super(props)
    this.state = {
      editAttendanceVisible: false,
      editAttendanceSelectedStatus: null,
      editAttendanceBlockId: null
    }
  }

  componentDidMount() {
    const { clientReference, scheduleId } = this.props.match.params
    this.loadData(clientReference, scheduleId)
  }

  loadData(clientReference, scheduleId) {
    const { clientId } = this.props
    this.props.getSchedule({ clientId, scheduleId })
    this.props.reportBlockAttendance({ clientId, scheduleId, clientReference })
    this.props.getContactAttendanceForSchedule({ clientId, scheduleId })
    this.props.getHolder({ clientId, clientReference })
  }

  handleEditAttendance = (blockId) => (event) => {
    event.preventDefault()
    this.setState({
      editAttendanceVisible: true,
      editAttendanceBlockId: blockId
    })
  }

  handleEditAttendanceCancel = () => {
    this.setState({
      editAttendanceVisible: false
    })
  }

  handleEditAttendanceSave = () => {
    const { clientId, match: { params: { clientReference, scheduleId } } } = this.props
    const { editAttendanceBlockId, editAttendanceSelectedStatus } = this.state

    this.props.overrideAttendance({
      clientId,
      clientReference,
      scheduleId,
      blockId: editAttendanceBlockId,
      status: editAttendanceSelectedStatus
    }).then(res => this.loadData(clientReference, scheduleId)).then(
      ()=>this.props.listScheduleStats({clientId})
    )


    this.setState({
      editAttendanceVisible: false
    })
  }

  handleNewAttendanceSelect = (key) => {
    this.setState({
      editAttendanceSelectedStatus: key
    })
  }

  handleNewAttendanceClear = () => {
    this.setState({
      editAttendanceSelectedStatus: null
    })
  }

  handlePrint = () => {
    window.print()
  }

  columns = () => {
    return [
      {
        title: "Date",
        dataIndex: "startTime",
        className: 'time',
        width: '65%',
        render:(text, record, index) => {
            return (
              <Fragment>
                {record.startTime.format('DD/MM/YYYY')},
                {' '}
                {record.startTime.format('HH:mm')} – {record.endTime.format('HH:mm')}
              </Fragment>
            )
          }
        },
      {
        title: "Attendance",
        dataIndex: "status",
        className: 'status',
        width: '35%',
        render: (text, record, index)=>(
          <Fragment>
            {absenceLabels[text]}
            {record.statusOverridden ? ' (manual) ' : ' '}
            <a
              className="no-print"
              onClick={this.handleEditAttendance(record.blockId)}
            >
              Edit
            </a>
          </Fragment>
        )
      },
    ]
  }

  render() {
    const { blockReport, committer, location, programme, schedule, loading, history } = this.props
    const sortedBlockReport = sortBlockReport(blockReport)
    const { clientReference } = this.props.match.params
    const processedCount = getProcessedCount(blockReport)
    const percentage = getAttendanceRate({
      presentCount: getPresentCount(blockReport),
      absentCount: getAbsentCount(blockReport)
    });

    return (
      <div className="attendanceScheduleBlockDrilldown section-to-print">
        {this.state.editAttendanceVisible &&
          <DialogBox>
            <h1>Edit Attendance</h1>
            <SearchableSelectField 
              inputId="newAttendanceStatus"
              inputClassName="unifi-input"
              data={absenceLabels}
              onItemSelect={this.handleNewAttendanceSelect}
              onSelectionClear={this.handleNewAttendanceClear}
            />
            <div className="buttons">
              <button
                className="unifi-button primary"
                disabled={this.editAttendanceSelectedStatus ? "disabled" : ""}
                onClick={this.handleEditAttendanceSave}
              >
                Save
              </button>
              <button
                className="unifi-button"
                onClick={this.handleEditAttendanceCancel}
              >
                Cancel
              </button>
            </div>
          </DialogBox>
        }
        <Row type="flex" justify="center" align="middle">
          <Col sm={20}>
            <a onClick={()=>history.goBack()}>&laquo; Back</a>
            <h1>{committer && committer.name}</h1>
          </Col>
          <Col sm={4} className="text-right">
            <Button className="no-print" onClick={this.handlePrint}>Print</Button>
          </Col>
        </Row>
        <h2>{schedule && schedule.name}</h2>
        <h3>Programme: {programme || '(None)'}</h3>
        <div className="schedule-stats-summary">
          <EvacuationProgressBar
            percentage={percentage}
            warningThreshold={90}
            criticalThreshold={70}
            tbd={!processedCount}
          />
          <p className="label">Overall Attendance</p>
          <div className="stats">
            <p className="stat"><span>Student ID:</span> {clientReference}</p>
            <p className="stat"><span>Lectures:</span> {blockReport.length}</p>
            <br />
            <p className="stat">
              <span>Present:</span> {getPresentCount(blockReport)}
            </p>
            <p className="stat">
              <span>Absent:</span> {getAbsentCount(blockReport)}
            </p>
          </div>
        </div>
        <div className="views">
          <p>Showing {blockReport.length} lectures</p>
        </div>
        <div>
          <Table
            className="unifi-table"
            dataSource={sortedBlockReport}
            columns={this.columns()}
            pagination={false}
            rowKey={(row)=> row.blockId}
            loading={loading}
          />
        </div>
      </div>
    )
  }
}

const selector = createStructuredSelector({
  blockReport: blockReportSelector,
  schedule: scheduleDetailsSelector,
  committer: committerSelector,
  programme: getHolderProgrammeSelector,
  loading: detectablesBlockReportLoadingSelector //TODO
})

const actions = {
  getContactAttendanceForSchedule,
  getHolder,
  getSchedule,
  overrideAttendance,
  reportBlockAttendance,
  listScheduleStats
}

export default compose(
  withRouter,
  connect(selector, actions),
  withClientId
)(AttendanceScheduleBlockDrilldown)



// WEBPACK FOOTER //
// ./src/pages/attendance/attendance-schedule-block-drilldown/index.js